import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";

//redux
import { withRouter, Link, useHistory } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import Logo from "../../assets/images/logo-large.png";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';


const ForgetPasswordPage = props => {
  //meta title
  document.title = "Forgot Password";
  const history = useHistory();
  const { getRequestWOAccessToken, postRequestWOAccessToken } = useRequestsWOAccessToken();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      userid: '',
    },
    validationSchema: Yup.object({
      userid: Yup.string()
        .max(255)
        .required('User name is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          userid: values.userid
        });
        const res = await postRequestWOAccessToken('forgot-password', jsonpar);
        if (res && res.code === 200) {
          let originalText = res.data;
          sendOTP(originalText, values.userid);
          
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();


      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

    const sendOTP = async (id, userid) => {
    const jsonpar = JSON.stringify({
      a_id: id,
    });

    const res = await postRequestWOAccessToken('send-otp', jsonpar);

    if (res && res.code === 200) {
      history.push("/change-password", {
            id: id,
            userid: userid,
            message: res.message,
            code: 200,
            status: "success",
          })
      // setAlertData((AlertData) => ({
      //   ...AlertData,
      //   variant: 'success',
      //   message: res.message,
      // }));
    } else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
        submit1.disabled = false;
        submit1.textContent = 'Submit';
    resetAlertData();
  };


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="account-pages bg-green">
        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody>

                  <Link to="/login" className="logo center-logo">
                    <span className="text-center">
                      <img src={Logo} alt="" />
                    </span>
                  </Link>
                  <h4 className="text-center mt-3 mb-3">Forgot your password ?</h4>

                  <div className="p-2">
                    <Form>
                      <div className="mb-3">
                        <Label className="form-label">User name :</Label>
                        <Input
                          name="userid" 
                          type="text" 
                          placeholder={'Enter User name'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.userid || ""}
                          invalid={
                            validation1.touched.userid && validation1.errors.userid ? true : false
                          }
                        />
                        {validation1.touched.userid && validation1.errors.userid ? (
                          <FormFeedback type="invalid">{validation1.errors.userid}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                            className="btn  btn-block" style={{ backgroundColor: '#266199', color: '#fff', border: 'none', width: '100%', padding: '0.5rem 1rem', borderRadius: '0.25rem' }}> {'Submit'} </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p style={{ color: '#266199' }}> Go back to{" "} <Link to="/login" className="font-weight-medium text-underline"> Login </Link>
                </p>
                <p style={{ color: '#266199' }}> © {new Date().getFullYear()} Utilize Safety.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
